import Reveal from "@/components/landing/Reveal";

const chapters = [
  {
    index: "01",
    title: "The Antidote to Job-Board Noise",
    content:
      "Endless scrolling, ghost listings, and applications that vanish into the void — modern job hunting has become a full-time job. At Vacansee, we believe the right role should find you through clarity, not volume.",
    img: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=80",
  },
  {
    index: "02",
    title: "Vetted, Every Single Role",
    content:
      "Every company on Vacansee is audited before it lists: real openings, published salary bands, and a culture we would join ourselves. If it does not pass, it does not ship.",
    img: "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1200&q=80",
  },
  {
    index: "03",
    title: "Technology in Service of People",
    content:
      "Our upcoming platform uses quiet intelligence to match how you want to work with teams that need exactly that — taking the cognitive fatigue out of the search.",
    img: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200&q=80",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-24 sm:py-32 lg:py-36 bg-sand-deep/60 border-y border-ink/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal className="mb-16 sm:mb-20">
          <p data-testid="manifesto-eyebrow" className="font-mono text-xs uppercase tracking-[0.25em] text-bronze mb-4">
            About · The Manifesto
          </p>
          <h2 data-testid="manifesto-heading" className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight max-w-2xl">
            Three chapters on why we are <span className="italic text-bronze">fixing hiring</span>
          </h2>
        </Reveal>

        <div className="space-y-20 sm:space-y-28">
          {chapters.map((c, i) => (
            <Reveal key={c.index} data-testid={`manifesto-chapter-${c.index}`}>
              <div
                className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center ${
                  i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="lg:col-span-7" data-testid={`manifesto-chapter-${c.index}`}>
                  <span className="font-mono text-5xl sm:text-7xl font-medium text-ink/10 block mb-4">{c.index}</span>
                  <h3 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight mb-5">{c.title}</h3>
                  <p className="text-base sm:text-lg font-light text-ink-soft leading-relaxed max-w-xl">{c.content}</p>
                </div>
                <div className="lg:col-span-5">
                  <div className="overflow-hidden rounded-3xl border border-ink/10 shadow-[0_24px_60px_rgba(13,27,42,0.12)]">
                    <img
                      src={c.img}
                      alt={c.title}
                      loading="lazy"
                      className="h-64 sm:h-80 w-full object-cover hover:scale-[1.04] transition-transform duration-700 ease-out"
                    />
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
